import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { LoaderPageContainer, PasswordInput, PasswordValidationTypography,
// PhoneInput,
SimpleModal, toast } from '@livable/saas-react-components';
import { Typography, TextField, Button, Grid, FormGroup, FormControlLabel, Checkbox, Link, LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { track, events } from 'src/configs/amplitude';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import SplitPageContainer from 'src/components/shared/SplitPageContainer';
import houseSvg from 'src/img/house.svg';
import { signUpInitialValues, signUpSchema } from 'src/utils/formValidation/SignUp';
import { PASSWORD_RULES_ERROR, PASSWORD_REQUIRED_ERROR } from 'src/utils/formValidation/SignUp';
import useStyles from './styles';
import { useFormik } from 'formik';
import PrivacyPolicy from 'src/components/general/PrivacyPolicy';
import { useStore } from 'src/stores';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import InputMask from 'react-input-mask';
import { observer } from 'mobx-react-lite';
export const PMSignUpPage = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Sign Up';
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    termsAndConditionModalState = _useState2[0],
    setTermsAndConditionModalState = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    termAndConditionChecked = _useState4[0],
    setTermAndConditionChecked = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    privacyPolicyModalState = _useState6[0],
    setPrivacyPolicyModalState = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    privacyPolicyChecked = _useState8[0],
    setPrivacyPolicyChecked = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    userAcknowledgmentModalState = _useState0[0],
    setUserAcknowledgmentModalState = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    userAcknowledgmentChecked = _useState10[0],
    setUserAcknowledgmentChecked = _useState10[1];
  const formik = useFormik({
    initialValues: signUpInitialValues,
    validationSchema: signUpSchema,
    onSubmit: async values => {
      track(events.clicked('Sign Up'), {
        page
      });
      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const data = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phone: "".concat(phoneCode).concat(values.phone.replace(/[^0-9+]/g, '')),
        password: values.password,
        termsAndConditions: values.termsAndConditions && values.privacyPolicy && values.userAcknowledgment
      };
      try {
        const resp = await store.account.registerNewAccountAsync.run(beforeSubmitDataValidation(data));
        formik.setFieldValue('termsAndConditions', false);
        formik.setFieldValue('privacyPolicy', false);
        formik.setFieldValue('userAcknowledgment', false);
        if (resp && resp.isSuccessful) {
          await store.account.getProfileAsync.run();
          navigate('/profile_saved');
        } else {
          formik.setFieldValue('termsAndConditions', values.termsAndConditions);
          formik.setFieldValue('privacyPolicy', values.privacyPolicy);
          formik.setFieldValue('userAcknowledgment', values.userAcknowledgment);
        }
      } catch (e) {
        toast('error', store.account.registerNewAccountAsync.error.errorRespe);
      }
    }
  });
  useEffect(() => {
    Promise.all([formik.setFieldValue('termsAndConditions', termAndConditionChecked), formik.setFieldValue('privacyPolicy', privacyPolicyChecked), formik.setFieldValue('userAcknowledgment', userAcknowledgmentChecked)]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termsAndConditionModalState, termAndConditionChecked, privacyPolicyModalState, privacyPolicyChecked, userAcknowledgmentModalState, userAcknowledgmentChecked, formik.isValid]);
  const leftBlockContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    color: "white"
  }, t('sign_up_flow.two_months'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "white"
  }, t('sign_up_flow.livable_is_the_only'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "white"
  }, t('sign_up_flow.create_an_account'))));

  // Terms And Conditions events

  const openTermsAndConditionModal = () => {
    setTermsAndConditionModalState(true);
    track(events.modalOpened('Terms'), {
      page
    });
  };
  const closeTermsAndConditionModal = () => {
    setTermsAndConditionModalState(false);
    track(events.modalClosed('Terms'), {
      page
    });
  };
  const acceptTermsAndCondition = () => {
    setTermAndConditionChecked(true);
    track(events.accepted('Terms'), {
      page
    });
    setTermsAndConditionModalState(false);
  };
  const refuseTermsAndCondition = () => {
    setTermAndConditionChecked(false);
    track(events.refused('Terms'), {
      page
    });
  };
  const toggleTermsAndCondition = () => termAndConditionChecked ? refuseTermsAndCondition() : openTermsAndConditionModal();

  // Privacy Policy events

  const openPrivacyPolicyModal = () => {
    setPrivacyPolicyModalState(true);
    track(events.modalOpened('Policy'), {
      page
    });
  };
  const closePrivacyPolicyModal = () => {
    setPrivacyPolicyModalState(false);
    track(events.modalClosed('Policy'), {
      page
    });
  };
  const acceptPrivacyPolicy = () => {
    setPrivacyPolicyChecked(true);
    track(events.accepted('Policy'), {
      page
    });
    setPrivacyPolicyModalState(false);
  };
  const refusePrivacyPolicy = () => {
    setPrivacyPolicyChecked(false);
    track(events.refused('Policy'), {
      page
    });
  };
  const togglePrivacyPolicy = () => privacyPolicyChecked ? refusePrivacyPolicy() : openPrivacyPolicyModal();

  // User Acknowledgment events

  const openUserAcknowledgmentModal = () => {
    setUserAcknowledgmentModalState(true);
    track(events.modalOpened('User Ack'), {
      page
    });
  };
  const closeUserAcknowledgmentModal = () => {
    setUserAcknowledgmentModalState(false);
    track(events.modalClosed('User Ack'), {
      page
    });
  };
  const acceptUserAcknowledgment = () => {
    setUserAcknowledgmentChecked(true);
    track(events.accepted('User Ack'), {
      page
    });
    setUserAcknowledgmentModalState(false);
  };
  const refuseUserAcknowledgment = () => {
    setUserAcknowledgmentChecked(false);
    track(events.refused('User Ack'), {
      page
    });
  };
  const toggleUserAcknowledgment = () => userAcknowledgmentChecked ? refuseUserAcknowledgment() : openUserAcknowledgmentModal();
  return /*#__PURE__*/React.createElement(React.Fragment, null, !store.account.registerNewAccountAsync.inProgress && !store.account.getProfileAsync.inProgress && /*#__PURE__*/React.createElement(SplitPageContainer, {
    imageScr: houseSvg,
    leftBlock: leftBlockContent
  }, /*#__PURE__*/React.createElement("form", {
    id: "signup-form",
    name: "signup-form",
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    gutterBottom: true
  }, t('general.lets_get_to_know')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 10,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    label: t('general.first_name'),
    variant: "outlined",
    value: formik.values.firstName,
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('First Name'), {
          page
        });
      }
    },
    onChange: formik.handleChange,
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && t(formik.errors.firstName, {
      field: t('general.first_name')
    })
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.last_name'),
    variant: "outlined",
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    value: formik.values.lastName,
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('Last Name'), {
          page
        });
      }
    },
    onChange: formik.handleChange,
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && t(formik.errors.lastName, {
      field: t('general.last_name')
    })
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "email",
    name: "email",
    variant: "outlined",
    label: t('general.email_address'),
    value: formik.values.email,
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('Email'), {
          page
        });
      }
    },
    onChange: formik.handleChange,
    error: formik.touched.email && Boolean(formik.errors.email),
    helperText: formik.touched.email && t(formik.errors.email, {
      field: t('general.email_address')
    })
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: formik.handleChange,
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) {
        formik.setFieldTouched('phone', true);
        track(events.filled('Phone'), {
          page
        });
      }
    }
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    helperText: formik.touched.phone && t(formik.errors.phone, {
      field: t('general.phone_number')
    })
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    gutterBottom: true,
    title: t('Please fill in all of the above fields'),
    isValidated: formik.touched.firstName && formik.touched.lastName && formik.touched.email && formik.touched.phone,
    isInvalid: formik.errors.firstName || formik.errors.lastName || formik.errors.email || formik.errors.phone
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('sign_up_flow.create_password')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    title: t('errors.password_validation_length'),
    isValidated: formik.touched.password,
    isInvalid: formik.errors.password === PASSWORD_REQUIRED_ERROR || formik.values.password.trim().length < 8
  }), /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    title: t('errors.password_validation_chars'),
    isValidated: formik.touched.password,
    isInvalid: formik.errors.password === PASSWORD_REQUIRED_ERROR || formik.errors.password === PASSWORD_RULES_ERROR
  }), /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    gutterBottom: true,
    title: t('errors.password_validation_match'),
    isValidated: formik.touched.repPassword,
    isInvalid: !!formik.errors.repPassword
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    label: t('general.set_password'),
    id: "password",
    name: "password",
    value: formik.values.password,
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('Password'), {
          page
        });
      }
    },
    onChange: formik.handleChange,
    error: formik.touched.password && Boolean(formik.errors.password)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    label: t('general.repeat_password'),
    id: "repPassword",
    name: "repPassword",
    value: formik.values.repPassword,
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('Repeat Password'), {
          page
        });
      }
    },
    onChange: formik.handleChange,
    error: formik.touched.repPassword && Boolean(formik.errors.repPassword)
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      id: "termsAndConditions",
      name: "termsAndConditions",
      checked: termAndConditionChecked,
      onChange: toggleTermsAndCondition
    }),
    label: /*#__PURE__*/React.createElement("span", {
      className: classes.termsConditionsLine
    }, t('general.i_agree_with'), ' ', /*#__PURE__*/React.createElement(SimpleModal, {
      trigger: /*#__PURE__*/React.createElement(Link, {
        href: "#"
      }, t('general.terms_and_conditions')),
      handleOpen: openTermsAndConditionModal,
      handleClose: closeTermsAndConditionModal,
      isOpen: termsAndConditionModalState,
      title: t('general.terms_and_conditions'),
      noPadding: true
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.modalScrollableContent
    }, /*#__PURE__*/React.createElement(PrivacyPolicy, null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      id: "acceptTermsButton",
      fullWidth: true,
      onClick: acceptTermsAndCondition,
      'custom-attribute': '717-pm-sign-up-page'
    }, t('general.terms_and_conditions_accept')))))
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      id: "privacyPolicy",
      name: "privacyPolicy",
      checked: privacyPolicyChecked,
      onChange: togglePrivacyPolicy,
      'custom-attribute': '718-pm-sign-up-page'
    }),
    label: /*#__PURE__*/React.createElement("span", {
      className: classes.termsConditionsLine
    }, t('general.i_agree_with'), ' ', /*#__PURE__*/React.createElement(SimpleModal, {
      trigger: /*#__PURE__*/React.createElement(Link, {
        href: "#"
      }, t('general.privacy_policy')),
      isOpen: privacyPolicyModalState,
      handleOpen: openPrivacyPolicyModal,
      handleClose: closePrivacyPolicyModal,
      title: t('general.privacy_policy'),
      noPadding: true
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.modalScrollableContent
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t('general.privacy_policy_body')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      id: "acceptPrivacyButton",
      fullWidth: true,
      onClick: acceptPrivacyPolicy,
      'custom-attribute': '723-pm-sign-up-page'
    }, t('general.privacy_policy_accept')))), ' ')
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      id: "userAcknowledgment",
      name: "userAcknowledgment",
      checked: userAcknowledgmentChecked,
      onChange: toggleUserAcknowledgment,
      'custom-attribute': '719-pm-sign-up-page'
    }),
    label: /*#__PURE__*/React.createElement("span", {
      className: classes.termsConditionsLine
    }, t('general.i_agree_with'), ' ', /*#__PURE__*/React.createElement(SimpleModal, {
      trigger: /*#__PURE__*/React.createElement(Link, {
        href: "#"
      }, t('general.user_acknowledgment')),
      isOpen: userAcknowledgmentModalState,
      handleOpen: openUserAcknowledgmentModal,
      handleClose: closeUserAcknowledgmentModal,
      title: t('general.user_acknowledgment'),
      noPadding: true
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.modalScrollableContent
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t('general.user_acknowledgment_body')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      id: "acceptWarningButton",
      fullWidth: true,
      onClick: acceptUserAcknowledgment,
      'custom-attribute': '720-pm-sign-up-page'
    }, t('general.user_acknowledgment_accept')))))
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Button, {
    id: "saveProfile",
    disabled: !formik.isValid || !Object.keys(formik.touched).length || store.account.getProfileAsync.inProgress || store.account.registerNewAccountAsync.inProgress,
    variant: "priority",
    type: "submit",
    fullWidth: true,
    'custom-attribute': '721-pm-sign-up-page'
  }, t('buttons.save_profile')))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    variant: "text",
    to: "/login",
    fullWidth: true,
    disabled: store.account.getProfileAsync.inProgress || store.account.registerNewAccountAsync.inProgress,
    onClick: () => track(events.clicked('Login'), {
      page
    }),
    'custom-attribute': '722-pm-sign-up-page'
  }, t('general.already_signed_up')))), (store.account.registerNewAccountAsync.inProgress || store.account.getProfileAsync.inProgress) && /*#__PURE__*/React.createElement(LoaderPageContainer, null, /*#__PURE__*/React.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1"
  }, t('general.creating_profile')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.additionalInfo
  }, t('general.please_wait_while_saving_details')), /*#__PURE__*/React.createElement(LinearProgress, null))));
});